import { useState } from 'react';
import { Link } from 'react-router-dom';
import PdfViewerModal, { shouldOpenPdfInNewTab } from '@/components/PdfViewerModal';
import { academyMenu } from '@/components/SiteTopNav/academyMenu';
import styles from './index.module.scss';

// Icon, href and pdf come from the Academy menu so both stay in sync
const academyItemByLabel = new Map(
  academyMenu.flatMap(group => group.items).map(i => [i.label, i])
);
const SUPPORT_CARDS = [
  {
    label: 'Installation',
    cta: 'Learn more',
    description: 'Site prep, acclimation and step-by-step guidance for a flawless lay.',
  },
  {
    label: 'Care',
    cta: 'Learn more',
    description: 'Daily cleaning and seasonal habits that keep your finish beautiful.',
  },
  {
    label: 'Warranty',
    cta: 'View warranty',
    description: "What's covered, for how long, and how to keep your coverage valid.",
  },
].map(card => ({ ...academyItemByLabel.get(card.label), ...card }));

const SupportCardBody = ({ card }) => (
  <>
    <span
      className={styles['support-icon']}
      style={{ '--support-icon': `url("${card.icon}")` }}
      aria-hidden="true"
    />
    <h3 className={styles['support-title']}>{card.label}</h3>
    <p className={styles['support-desc']}>{card.description}</p>
    <span className={styles['support-cta']}>
      {card.cta}
      <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
        <path
          d="M5 12h14M13 6l6 6-6 6"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  </>
);

/** Installation, Care and Warranty link cards, shared by the home and product detail pages */
const SupportCards = ({ className }) => {
  const [pdfViewer, setPdfViewer] = useState(null);

  return (
    <>
      <div className={[styles['support-grid'], className].filter(Boolean).join(' ')}>
        {SUPPORT_CARDS.map(card =>
          card.pdf ? (
            <a
              key={card.label}
              className={styles['support-card']}
              href={card.pdf.url}
              target="_blank"
              rel="noopener noreferrer"
              data-motion="card"
              onClick={e => {
                if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || shouldOpenPdfInNewTab())
                  return;
                e.preventDefault();
                setPdfViewer(card.pdf);
              }}
            >
              <SupportCardBody card={card} />
            </a>
          ) : (
            <Link
              key={card.label}
              className={styles['support-card']}
              to={card.href}
              data-motion="card"
            >
              <SupportCardBody card={card} />
            </Link>
          )
        )}
      </div>

      <PdfViewerModal
        open={Boolean(pdfViewer)}
        url={pdfViewer?.url}
        title={pdfViewer?.title}
        onClose={() => setPdfViewer(null)}
      />
    </>
  );
};

export default SupportCards;
